import { Link } from 'react-router-dom';

import { PublicPageShell } from '@/components/layout/PageShell';
import { Button } from '@/components/ui/Button';

export const NotFoundPage = () => (
  <PublicPageShell mainClassName="items-center justify-center px-4 py-8">
    <div className="w-full max-w-lg rounded-3xl bg-white/90 px-8 py-8 text-center">
      <p className="text-8xl font-bold text-gray-200">404</p>
      <h2 className="mt-4 text-2xl font-bold text-gray-900">Strona nie znaleziona</h2>
      <p className="mt-2 text-gray-500">
        Strona, której szukasz, nie istnieje lub została przeniesiona.
      </p>
      <Link to="/" className="mt-6 inline-block">
        <Button>Wróć na stronę główną</Button>
      </Link>
    </div>
  </PublicPageShell>
);
